import React from "react";

const WheelPickerContext = React.createContext<{ id: string }>({ id: "" });
const WheelPickerContextProvider = WheelPickerContext.Provider;
export { WheelPickerContext, WheelPickerContextProvider };
